/**
 * StickyAgentBadge — small indicator showing which agent the next message will
 * route to (the conversation's current sticky agent, or "jared" by default).
 */

import { COLORS, SPACE, TYPE } from "../theme/index.js";
import type { ChatAssistant } from "./types.js";

const LABELS: Record<ChatAssistant, string> = {
  jared: "Jared",
  russ: "Russ",
  richard: "Richard",
};

export interface StickyAgentBadgeProps {
  assistant: ChatAssistant;
}

export function StickyAgentBadge({ assistant }: StickyAgentBadgeProps) {
  return (
    <div
      data-testid="sticky-agent-badge"
      data-assistant={assistant}
      style={{
        padding: `${SPACE[1]}px ${SPACE[3]}px`,
        fontSize: TYPE.size.xs,
        color: COLORS.textDim,
        display: "flex",
        gap: SPACE[1],
      }}
    >
      <span>Talking to:</span>
      <span style={{ color: COLORS.brandText, fontWeight: TYPE.weight.medium }}>
        {LABELS[assistant]}
      </span>
      <span style={{ color: COLORS.textGhost }}>· @-mention to switch</span>
    </div>
  );
}
